class AnimateAccordion extends HTMLElement {
    constructor() {
        super(),
            (this.details = this.querySelector("details")),
            (this.summary = this.querySelector("summary")),
            (this.content = this.querySelector(".details-content")),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            (this.cachedHeight = null),
            this.init();
    }
    init() {
        this.summary.addEventListener("click", (e) => this.onClick(e));
    }
    onClick(e) {
        e.preventDefault(),
            (this.content.style.overflow = "hidden"),
            this.isClosing || !this.details.open
                ? (this.closeOtherAccordions(), this.open())
                : (this.isExpanding || this.details.open) && this.shrink();
    }
    closeOtherAccordions() {
        document.querySelectorAll("acordion-animated details[open]").forEach((e) => {
            e !== this.details && e.removeAttribute("open");
        });
    }
    shrink() {
        (this.isClosing = !0), this.cachedHeight || (this.cachedHeight = this.content.offsetHeight);
        const e = `${this.cachedHeight}px`;
        this.animation && this.animation.cancel(),
            (this.animation = this.content.animate({ height: [e, "0px"] }, { duration: 400, easing: "ease" })),
            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
            (this.animation.oncancel = () => (this.isClosing = !1));
    }
    open() {
        (this.details.open = !0), window.requestAnimationFrame(() => this.expand());
    }
    expand() {
        this.isExpanding = !0;
        const e = `${this.content.offsetHeight}px`;
        (this.cachedHeight = this.content.offsetHeight),
            this.animation && this.animation.cancel(),
            (this.animation = this.content.animate({ height: ["0px", e] }, { duration: 400, easing: "ease-out" })),
            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
            (this.animation.oncancel = () => (this.isExpanding = !1));
    }
    onAnimationFinish(e) {
        (this.details.open = e),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            (this.content.style.height = ""),
            (this.content.style.overflow = ""),
            (this.cachedHeight = null);
    }
}
customElements.define("acordion-animated", AnimateAccordion);


class DetailsWrapper extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const accordions = this.querySelectorAll("acordion-animated");

    accordions.forEach((accordion) => {
      const details = accordion.querySelector("details");

      details.addEventListener("toggle", () => {
        if (details.open) {
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              const otherDetails = otherAccordion.querySelector("details");

              if (otherDetails.open && !otherAccordion.isClosing) {
                setTimeout(() => {
                  otherAccordion.shrink(); 
                }, 400);
              }
            }
          });
        }
      });
    });
  }
}

customElements.define("details-wrapper", DetailsWrapper);

class TestimonialsSlide extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    // Only initialize if not already done
    if (!this.initialized) {
      this.initSwiper();
    }
  }

  initSwiper() {
    const container = this.querySelector('.js-testimonials-carousel');
    if (!container) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      slidesOffsetAfter: 15,
      a11y: true,
      freeMode: true,
      breakpoints: {
        769: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          slidesOffsetAfter: 0,
        },
        1100: {
          slidesPerView: 2, 
          spaceBetween: 20,
          slidesOffsetAfter: 0,
        }
      }
    });
    this.initialized = true;
  }
}

if (!customElements.get('testimonials-slides')) {
  customElements.define('testimonials-slides', TestimonialsSlide);
}


// Subscription JS

const observer = new MutationObserver((mutations, obs) => {
  const mainSubscription = document.querySelector(".kaching-bundles");

  if (mainSubscription) {
    const titleList = mainSubscription.querySelectorAll(".kaching-bundles__bar-title");
    
    if (titleList.length > 0) {
      titleList.forEach((el) => {
        let text = el.textContent;
        text = text.replace(/Toll/gi, "Tool");
        if (text.includes(",")) {
          const parts = text.split(",");
          el.innerHTML = `${parts[0].trim()},<strong>${parts[1].trim()}</strong>`;
        } else {
          el.textContent = text;
        }
      });

      obs.disconnect();
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});